import { styled } from "@mui/material/styles";
import Icon from "@mui/material/Icon";
import ListItem from "@mui/material/ListItem";
import { useFormContext } from "react-hook-form";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { setPayment } from "store/vino/checkoutSlice";

const StyledListItem = styled(ListItem)(({ theme, completed }) => ({
	...(completed && {
		background: "rgba(0,0,0,0.03)",
		"& .address-title, & .address": {
			textDecoration: "line-through",
		},
	}),
}));

function PaymentListItem({ payment }) {
	const { setValue } = useFormContext();
	const dispatch = useDispatch();
	const selectedPayment = useSelector(({ vino }) => vino.checkout.payment);
	const selected = selectedPayment?.id === payment.id;

	const handleSelect = () => {
		dispatch(setPayment(payment));
		setValue("paymentMethodId", payment.id, {
			shouldValidate: true,
			shouldTouch: true,
		});
	};

	const { card } = payment;

	return (
		<StyledListItem
			className="px-0 sm:px-8"
			onClick={handleSelect}
			dense
			button
		>
			{selected ? (
				<Icon color="secondary" className="fa-solid fa-circle-check" />
			) : (
				<Icon color="action" className="fa-solid fa-circle" />
			)}

			<div className="flex flex-1 flex-col relative overflow-hidden px-8">
				<Typography className="todo-title text-14 font-medium">
					<span className="font-semibold mr-2">Card ending in</span>
					{card.last4}
				</Typography>
				<Typography color="textSecondary">{card.nameOnCard}</Typography>
			</div>
			<div className="px-8"></div>
			<div className="px-8">
				<Typography className="todo-title text-14 font-medium">
					{card.expMonth}/{card.expYear}
				</Typography>
			</div>
		</StyledListItem>
	);
}

export default PaymentListItem;
